import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useScreen } from 'Screen/ScreenContext';

import useHome from './hooks/useHome';
import HomeView from './view';

/**
 * Home — the root splash screen ("/").
 *
 * Controller only: sets the document title, clears any breadcrumb left by the
 * previous page (the root has no trail to walk back on) and hands the hook
 * state to the pure view.
 */
export default function Home() {
    const { t } = useTranslation('dashboard');

    document.title = t('home.documentTitle');

    const { setBreadcrumb, setBreadcrumbAction } = useScreen();
    const home = useHome();

    useEffect(() => {
        setBreadcrumb(null);
        setBreadcrumbAction(null);
    }, [setBreadcrumb, setBreadcrumbAction]);

    return <HomeView {...home} />;
}
